import { PageObject, PAGEOBJECTTYPE } from "./pageobject";
import { ObjectProperty, OBJECTPROPERTYTYPE } from "./objectproperty";

export class PageObjectSelection extends PageObject {
  imageNormal: string;
  imageSelect: string;
  groupName: string;
  selected: boolean;

  constructor(obj: PageObjectSelection = null, style: string = "") {
    super(obj);
    this._type = PAGEOBJECTTYPE.Selection;

    if (obj == null) {
      this.imageNormal = "";
      this.imageSelect = "";
      this.groupName = "";
      this.selected = false;
    } else {
      this.imageNormal = obj.imageNormal;
      this.imageSelect = obj.imageSelect;
      this.groupName = obj.groupName;
      this.selected = obj.selected;
    }
  }

  getPropertiesList(): ObjectProperty[] {
    let list = super.getPropertiesList();

    list.push(new ObjectProperty("Image Normal", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Image Select", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Group Name", OBJECTPROPERTYTYPE.Text));
    list.push(new ObjectProperty("Selected", OBJECTPROPERTYTYPE.Boolean));

    return list;
  }

  getPropertyValue(name: string): any {
    if (name == "Image Normal") {
      return this.imageNormal;
    } else if (name == "Image Select") {
      return this.imageSelect;
    } else if (name == "Group Name") {
      return this.groupName;
    } else if (name == "Selected") {
      return this.selected;
    }

    return super.getPropertyValue(name);
  }

  setPropertyValue(name: string, value: any, style: string): void {
    super.setPropertyValue(name, value, style);

    if (name == "Image Normal") {
      this.imageNormal = value;
    } else if (name == "Image Select") {
      this.imageSelect = value;
    } else if (name == "Group Name") {
      this.groupName = value;
    } else if (name == "Selected") {
      this.selected = value == "true";
    }
  }
}
